import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '../../directives/TranslatePipe';
import { BuildPresetRange, DateRangePreset } from '../../../helpers/dateRangeHelpers';

@Component({
  selector: 'app-date-range-select',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './date-range-select.component.html'
})
export class DateRangeSelectComponent {
  selectedRange: DateRangePreset = 'Today';

  // Positionne le selecteur sans reemettre : c'est le calendrier qui a produit la plage.
  @Input() set preset(value: DateRangePreset) {
    if (value !== this.selectedRange) this.selectedRange = value;
  }

  @Output() dateRangeChange = new EventEmitter<{ startDate: Date; endDate: Date; preset: DateRangePreset }>();

  onRangeChange(event: Event): void {
    this.selectedRange = (event.target as HTMLSelectElement).value as DateRangePreset;
    this.emitDateRange();
  }

  ngOnInit(): void {
    this.emitDateRange();
  }

  // Une periode libre n'a pas de bornes calculables : elles viennent du calendrier.
  private emitDateRange(): void {
    const range = BuildPresetRange(this.selectedRange);
    if (!range) return;

    this.dateRangeChange.emit({ ...range, preset: this.selectedRange });
  }
}
